import { Component, Renderer2, signal } from '@angular/core';
import { BServiceService } from '../../../Services/BService/b-service.service';
import { BSharedServiceService } from '../../../Services/BService/b-shared-service.service';
import { environment } from '../../../../Environment/environment';
import { PdfService } from '../../../Services/pdfServices/pdf.service';
import { MatDialog } from '@angular/material/dialog';
import { ImagePopUpComponent } from '../image-pop-up/image-pop-up.component';
import { PdfDialogComponent } from '../../pdf-dialog/pdf-dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UserRegisterService } from '../../../Services/Registration/user-register.service';
import { SharedUserRegisterService } from '../../../Services/Registration/shared-user-register.service';
import { HttpClient } from '@angular/common/http';
import { SendMailService } from '../../../Services/SendMail/send-mail.service';
import { SharedDataService } from '../../../Services/SharedServices/shared-data.service';
import { CadService } from '../../../Services/CADServices/cad.service';
import { NemaService } from '../../../Services/nema.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

declare var bootstrap: any;

@Component({
  selector: 'app-b-final-selection',
  templateUrl: './b-final-selection.component.html',
  styleUrl: './b-final-selection.component.css',
  providers: [MessageService]
})
export class BFinalSelectionComponent {
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  scrollToCommonFirstComponent() {
    const firstComponent = document.querySelector('app-first-selection');
    if (firstComponent) {
      firstComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  public userDetails!: FormGroup;
  public requestDetails!: FormGroup;
  private init(): void {
    this.userDetails = this.formBuilder.group({
      fName: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
      lName: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
      company: [null, [Validators.required, Validators.pattern(/^[A-Za-z0-9\s&.,'-]+$/)]],
      city: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
      state: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
      country: ['', [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required, Validators.pattern(/^(\+?\d{1,4}[-]?)?\d{5,15}$/)]],
      comment: [null],
      quantity: [null,],
      policyCheck: [false, Validators.requiredTrue]
    });
  }

  private validateRequestQuote(): void {
    this.requestDetails = this.formBuilder.group({
      requestQuantity: [null, Validators.required],
      requestComments: [null,]
    });
  }

  private countryNameToCode: { [key: string]: string } = {
    'united states': 'USA',
    'afghanistan': 'AFG',
    'åland islands': 'ALA',
    'aland islands': 'ALA',
    'albania': 'ALB',
    'algeria': 'DZA',
    'american samoa': 'ASM',
    'andorra': 'AND',
    'angola': 'AGO',
    'anguilla': 'AIA',
    'antarctica': 'ATA',
    'antigua and barbuda': 'ATG',
    'argentina': 'ARG',
    'armenia': 'ARM',
    'aruba': 'ABW',
    'australia': 'AUS',
    'austria': 'AUT',
    'azerbaijan': 'AZE',
    'bahamas': 'BHS',
    'bahrain': 'BHR',
    'bangladesh': 'BGD',
    'barbados': 'BRB',
    'belarus': 'BLR',
    'belgium': 'BEL',
    'belize': 'BLZ',
    'benin': 'BEN',
    'bermuda': 'BMU',
    'bhutan': 'BTN',
    'bolivia, plurinational state of': 'BOL',
    'bolivia': 'BOL',
    'bonaire, sint eustatius and saba': 'BES',
    'bosnia and herzegovina': 'BIH',
    'botswana': 'BWA',
    'bouvet island': 'BVT',
    'brazil': 'BRA',
    'british indian ocean territory': 'IOT',
    'brunei darussalam': 'BRN',
    'brunei': 'BRN',
    'bulgaria': 'BGR',
    'burkina faso': 'BFA',
    'burundi': 'BDI',
    'cambodia': 'KHM',
    'cameroon': 'CMR',
    'canada': 'CAN',
    'cape verde': 'CPV',
    'cayman islands': 'CYM',
    'central african republic': 'CAF',
    'chad': 'TCD',
    'chile': 'CHL',
    'china': 'CHN',
    'christmas island': 'CXR',
    'cocos (keeling) islands': 'CCK',
    'colombia': 'COL',
    'comoros': 'COM',
    'congo': 'COG',
    'congo, the democratic republic of the': 'COD',
    'cook islands': 'COK',
    'costa rica': 'CRI',
    "côte d'ivoire": 'CIV',
    "cote d'ivoire": 'CIV',
    'ivory coast': 'CIV',
    'croatia': 'HRV',
    'cuba': 'CUB',
    'curaçao': 'CUW',
    'curacao': 'CUW',
    'cyprus': 'CYP',
    'czech republic': 'CZE',
    'denmark': 'DNK',
    'djibouti': 'DJI',
    'dominica': 'DMA',
    'dominican republic': 'DOM',
    'ecuador': 'ECU',
    'egypt': 'EGY',
    'el salvador': 'SLV',
    'equatorial guinea': 'GNQ',
    'eritrea': 'ERI',
    'estonia': 'EST',
    'ethiopia': 'ETH',
    'falkland islands (malvinas)': 'FLK',
    'falkland islands': 'FLK',
    'faroe islands': 'FRO',
    'fiji': 'FJI',
    'finland': 'FIN',
    'france': 'FRA',
    'french guiana': 'GUF',
    'french polynesia': 'PYF',
    'french southern territories': 'ATF',
    'gabon': 'GAB',
    'gambia': 'GMB',
    'georgia': 'GEO',
    'germany': 'DEU',
    'ghana': 'GHA',
    'gibraltar': 'GIB',
    'greece': 'GRC',
    'greenland': 'GRL',
    'grenada': 'GRD',
    'guadeloupe': 'GLP',
    'guam': 'GUM',
    'guatemala': 'GTM',
    'guernsey': 'GGY',
    'guinea': 'GIN',
    'guinea-bissau': 'GNB',
    'guyana': 'GUY',
    'haiti': 'HTI',
    'heard island and mcdonald islands': 'HMD',
    'holy see (vatican city state)': 'VAT',
    'vatican': 'VAT',
    'honduras': 'HND',
    'hong kong': 'HKG',
    'hungary': 'HUN',
    'iceland': 'ISL',
    'india': 'IND',
    'indonesia': 'IDN',
    'iran, islamic republic of': 'IRN',
    'iran': 'IRN',
    'iraq': 'IRQ',
    'ireland': 'IRL',
    'isle of man': 'IMN',
    'israel': 'ISR',
    'italy': 'ITA',
    'jamaica': 'JAM',
    'japan': 'JPN',
    'jersey': 'JEY',
    'jordan': 'JOR',
    'kazakhstan': 'KAZ',
    'kenya': 'KEN',
    'kiribati': 'KIR',
    "korea, democratic people's republic of": 'PRK',
    'north korea': 'PRK',
    'korea, republic of': 'KOR',
    'south korea': 'KOR',
    'kuwait': 'KWT',
    'kyrgyzstan': 'KGZ',
    "lao people's democratic republic": 'LAO',
    'laos': 'LAO',
    'latvia': 'LVA',
    'lebanon': 'LBN',
    'lesotho': 'LSO',
    'liberia': 'LBR',
    'libya': 'LBY',
    'liechtenstein': 'LIE',
    'lithuania': 'LTU',
    'luxembourg': 'LUX',
    'macao': 'MAC',
    'macau': 'MAC',
    'macedonia, the former yugoslav republic of': 'MKD',
    'macedonia': 'MKD',
    'madagascar': 'MDG',
    'malawi': 'MWI',
    'malaysia': 'MYS',
    'maldives': 'MDV',
    'mali': 'MLI',
    'malta': 'MLT',
    'marshall islands': 'MHL',
    'martinique': 'MTQ',
    'mauritania': 'MRT',
    'mauritius': 'MUS',
    'mayotte': 'MYT',
    'mexico': 'MEX',
    'micronesia, federated states of': 'FSM',
    'micronesia': 'FSM',
    'moldova, republic of': 'MDA',
    'moldova': 'MDA',
    'monaco': 'MCO',
    'mongolia': 'MNG',
    'montenegro': 'MNE',
    'montserrat': 'MSR',
    'morocco': 'MAR',
    'mozambique': 'MOZ',
    'myanmar': 'MMR',
    'burma': 'MMR',
    'namibia': 'NAM',
    'nauru': 'NRU',
    'nepal': 'NPL',
    'netherlands': 'NLD',
    'new caledonia': 'NCL',
    'new zealand': 'NZL',
    'nicaragua': 'NIC',
    'niger': 'NER',
    'nigeria': 'NGA',
    'niue': 'NIU',
    'norfolk island': 'NFK',
    'northern mariana islands': 'MNP',
    'norway': 'NOR',
    'oman': 'OMN',
    'pakistan': 'PAK',
    'palau': 'PLW',
    'palestinian territory, occupied': 'PSE',
    'palestine': 'PSE',
    'panama': 'PAN',
    'papua new guinea': 'PNG',
    'paraguay': 'PRY',
    'peru': 'PER',
    'philippines': 'PHL',
    'pitcairn': 'PCN',
    'poland': 'POL',
    'portugal': 'PRT',
    'puerto rico': 'PRI',
    'qatar': 'QAT',
    'réunion': 'REU',
    'reunion': 'REU',
    'romania': 'ROU',
    'russian federation': 'RUS',
    'russia': 'RUS',
    'rwanda': 'RWA',
    'saint barthélemy': 'BLM',
    'saint barthelemy': 'BLM',
    'saint helena, ascension and tristan da cunha': 'SHN',
    'saint helena': 'SHN',
    'saint kitts and nevis': 'KNA',
    'saint lucia': 'LCA',
    'saint martin (french part)': 'MAF',
    'saint martin': 'MAF',
    'saint pierre and miquelon': 'SPM',
    'saint vincent and the grenadines': 'VCT',
    'samoa': 'WSM',
    'san marino': 'SMR',
    'sao tome and principe': 'STP',
    'saudi arabia': 'SAU',
    'senegal': 'SEN',
    'serbia': 'SRB',
    'seychelles': 'SYC',
    'sierra leone': 'SLE',
    'singapore': 'SGP',
    'sint maarten (dutch part)': 'SXM',
    'sint maarten': 'SXM',
    'slovakia': 'SVK',
    'slovenia': 'SVN',
    'solomon islands': 'SLB',
    'somalia': 'SOM',
    'south africa': 'ZAF',
    'south georgia and the south sandwich islands': 'SGS',
    'south sudan': 'SSD',
    'spain': 'ESP',
    'sri lanka': 'LKA',
    'sudan': 'SDN',
    'suriname': 'SUR',
    'svalbard and jan mayen': 'SJM',
    'swaziland': 'SWZ',
    'sweden': 'SWE',
    'switzerland': 'CHE',
    'syrian arab republic': 'SYR',
    'syria': 'SYR',
    'taiwan, province of china': 'TWN',
    'taiwan': 'TWN',
    'tajikistan': 'TJK',
    'tanzania, united republic of': 'TZA',
    'tanzania': 'TZA',
    'thailand': 'THA',
    'timor-leste': 'TLS',
    'east timor': 'TLS',
    'togo': 'TGO',
    'tokelau': 'TKL',
    'tonga': 'TON',
    'trinidad and tobago': 'TTO',
    'tunisia': 'TUN',
    'turkey': 'TUR',
    'turkmenistan': 'TKM',
    'turks and caicos islands': 'TCA',
    'tuvalu': 'TUV',
    'uganda': 'UGA',
    'ukraine': 'UKR',
    'united arab emirates': 'ARE',
    'uae': 'ARE',
    'united kingdom': 'GBR',
    'uk': 'GBR',
    'united states minor outlying islands': 'UMI',
    'uruguay': 'URY',
    'uzbekistan': 'UZB',
    'vanuatu': 'VUT',
    'venezuela, bolivarian republic of': 'VEN',
    'venezuela': 'VEN',
    'viet nam': 'VNM',
    'vietnam': 'VNM',
    'virgin islands, british': 'VGB',
    'virgin islands, u.s.': 'VIR',
    'wallis and futuna': 'WLF',
    'western sahara': 'ESH',
    'yemen': 'YEM',
    'zambia': 'ZMB',
    'zimbabwe': 'ZWE'
  };
  signalStatus: boolean = false;
  panelOpenState = signal(this.signalStatus);
  fileType: any;
  fileRequest: any;
  userLoginStatus: any;
  formSubmitted = false;
  requestFormSubmitted = false;
  buttonsArray = ["Btn_Quote", "Btn_Spec"];
  UserDBData: any = {};
  firstName: any;
  showSuccess(summary: any, detail: any) {
    this.messageService.add({
      severity: 'success',
      summary: summary,
      detail: detail,
      icon: 'pi pi-check-circle',
      life: 5000
    });
  }
  showConfirm(firstName: any) {
    const url = this.router.url.toLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) {
      this.messageService.add({
        key: 'confirm',  // Use the key to target the specific toast
        severity: 'info', // Set the severity level (info, success, etc.)
        icon: 'pi pi-check-circle',
        summary: "Hi " + firstName + ", your request has been sent to the Spinea sales team.", // Message title
        detail: "Our team will contact you soon. For any questions, please call +421 51 77 00 156.", // Message details

        life: 5000  // Duration the toast is visible (optional)
      });
    }
    else {
      this.messageService.add({
        key: 'confirm',  // Use the key to target the specific toast
        severity: 'info', // Set the severity level (info, success, etc.)
        icon: 'pi pi-check-circle',
        summary: "Hi " + firstName + ", your request has been sent to the Cone Drive sales team.", // Message title
        detail: "Our team will contact you soon. For any questions, please call 888.994.2663.", // Message details

        life: 5000  // Duration the toast is visible (optional)
      });
    }
  }
  // This method will be called when the "Reply" button inside the toast is clicked
  onConfirm() {
    console.log('Reply button clicked!');
    // You can implement additional logic here, such as navigating to another page, etc.
  }

  // This method will be called when the toast is closed
  onReject() {
    console.log('Toast closed');
    // Handle any cleanup or logic when the toast is dismissed
  }
  RequestQuote() {
    debugger;

    this.setFileType("Request Quote", "requestQuote");
    if (this.userLoginStatus == true) {
      document.cookie = "CookiesCode=" + this.productCode;
      const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("B (PowerMate)(spineatools)", "RequestQuoteClick");
      } else {
        this.setAnalytics("B (PowerMate)", "RequestQuoteClick");
      }
      // this.generatePdf();
      // alert("Here we will have our Request logic");
    } else {
      const modalElement = document.getElementById('commonRegisterModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }
  userQuickUpdate(typeofFile: any) {
    const userData = {
        FirstName: this.userDetails.get('fName')?.value,
        LastName: this.userDetails.get('lName')?.value,
        email: this.userDetails.get('email')?.value,
        Company: this.userDetails.get('company')?.value,
        City: this.userDetails.get('city')?.value,
        State: this.userDetails.get('state')?.value,
        Country: this.userDetails.get('country')?.value,
        ContactNumber: this.userDetails.get('phone')?.value,
        Quantity:this.requestDetails.get('requestQuantity')?.value,
        Request:this.fileRequest||null,
        Code:this.productCode,
        Comment:this.requestDetails.get('requestComments')?.value

      };

    this.userUpdate(JSON.stringify(userData), typeofFile);
  }
  DownloadSpec() {
    debugger;
    this.setFileType("Specification", "specification");

    if (this.userLoginStatus == true) {
      if (this.productCode != this.sharedDataService.getCookie("CookiesCode")) {
        document.cookie = "CookiesCode=" + this.productCode;
          const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('spineatools')) {
          this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
        } else {
          this.setAnalytics("B (PowerMate)", "RegisterClick");
        }
      }
      this.generatePdf();
      this.showSuccess("Success", "Spec Sheet has been Downloaded");
      this.userQuickUpdate("specification");

      // this.dialogRef.close();
    } else {
      const modalElement = document.getElementById('commonRegisterModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }
  Download2DDimFile() {
    debugger;
    this.setFileType("Drawing Download", "drawing2Ddownload");

    if (this.userLoginStatus == true) {
      if (this.productCode != this.sharedDataService.getCookie("CookiesCode")) {
        document.cookie = "CookiesCode=" + this.productCode;
        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('spineatools')) {
          this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
        } else {
          this.setAnalytics("B (PowerMate)", "RegisterClick");
        }
      }
      this.download2dDimensionedFileSeriesB();
      this.showSuccess("Success", "2D Dimensional File has been Downloaded");
      this.userQuickUpdate("drawing2Ddownload");

      // this.dialogRef.close();
    } else {
      const modalElement = document.getElementById('commonRegisterModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }
  showDrawingRegister() {
    this.setFileType("Drawing Download", "drawingdownload");

    // if(this.userLoginStatus == true){

    //     this.generatePdf();
    //     this.showSuccess("Success","Spec Sheet Downloaded");

    //     // this.dialogRef.close();
    // }else{
    const modalElement = document.getElementById('commonRegisterModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
    // }
  }
  download3DPDFWithStatus() {
    if (this.productCode != this.sharedDataService.getCookie("CookiesCode")) {
      document.cookie = "CookiesCode=" + this.productCode;
      const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
      } else {
        this.setAnalytics("B (PowerMate)", "RegisterClick");
      }
    }
    this.setFileType("Drawing Downloads", "drawingDownload");
    this.download3DPDF();
    this.showSuccess("Success", "3d PDF has been Downloaded");
    this.userQuickUpdate("drawingDownload");
  }
  download3DFileWithStatus() {
    if (this.productCode != this.sharedDataService.getCookie("CookiesCode")) {
      document.cookie = "CookiesCode=" + this.productCode;
      const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
      } else {
        this.setAnalytics("B (PowerMate)", "RegisterClick");
      }
    }
    this.setFileType("Drawing Downloads", "drawingDownload");
    this.download3DFile();
    this.showSuccess("Success", "3d File has been Downloaded");
    this.userQuickUpdate("drawingDownload");
  }
  download2DFileWithStatus() {
    if (this.productCode != this.sharedDataService.getCookie("CookiesCode")) {
      document.cookie = "CookiesCode=" + this.productCode;
      const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
      } else {
        this.setAnalytics("B (PowerMate)", "RegisterClick");
      }
    }
    this.setFileType("Drawing Downloads", "drawingDownload");
    this.download2DFile();
    this.showSuccess("Success", "2d File has been Downloaded");
    this.userQuickUpdate("drawingDownload");
  }
  funRemove() {
    const intervalId = setInterval(() => {
      let buttonsArray: string[] = ["Btn_Quote", "Btn_Spec", "Btn_DrawingDownload", "Btn_Dimension"];
      if (buttonsArray.length > 0) {
        buttonsArray.forEach(btnData => {
          const buttonElement = document.getElementById(btnData);
          if (buttonElement) {
            buttonElement.removeAttribute('data-bs-toggle');
            buttonElement.removeAttribute('data-bs-target');
            clearInterval(intervalId);
          }
        });
      }
    }, 1000);
  }
  funGet() {
    const intervalId = setInterval(() => {
      let buttonsArray: string[] = ["Btn_Quote", "Btn_Spec", "Btn_DrawingDownload", "Btn_Dimension"];
      if (buttonsArray.length > 0) {
        buttonsArray.forEach(btnData => {
          const buttonElement = document.getElementById(btnData);
          if (buttonElement) {
            buttonElement.setAttribute('data-bs-toggle', 'modal');
            buttonElement.setAttribute('data-bs-target', '#commonRegisterModal');
            clearInterval(intervalId);
          }
        });
      }
    }, 1000);
  }
  assignRequestQuote() {
    const intervalId = setInterval(() => {
      let buttonsArray: string[] = ["Btn_Quote"];
      if (buttonsArray.length > 0) {
        buttonsArray.forEach(btnData => {
          const buttonElement = document.getElementById(btnData);
          if (buttonElement) {
            buttonElement.setAttribute('data-bs-toggle', 'modal');
            buttonElement.setAttribute('data-bs-target', '#sendQuoteModal');
            clearInterval(intervalId);
          }
        });
      }
    }, 1000);
  }
  setFileType(fileName: any, filetype: any) {
    this.fileType = filetype;
    this.fileRequest = fileName;
  }
  processQuoteSubmit() {
    debugger;
    this.requestFormSubmitted = true;
    if (this.requestDetails.valid) {
      const userData = {
        FirstName: this.userDetails.get('fName')?.value,
        LastName: this.userDetails.get('lName')?.value,
        email: this.userDetails.get('email')?.value,
        Company: this.userDetails.get('company')?.value,
        City: this.userDetails.get('city')?.value,
        State: this.userDetails.get('state')?.value,
        Country: this.userDetails.get('country')?.value,
        ContactNumber: this.userDetails.get('phone')?.value,
        Quantity:this.requestDetails.get('requestQuantity')?.value,
        Request:this.fileRequest||null,
        Code:this.productCode,
        Comment:this.requestDetails.get('requestComments')?.value

      };
      this.quoteUserData = {
        quantity: userData.Quantity,
        email: userData.email,
        firstName: userData.FirstName,
        lastName: userData.LastName,
        company: userData.Company,
        city: userData.City,
        state: userData.State,
        country: userData.Country,
        mobile: userData.ContactNumber,
        comment: userData.Comment
      };

      this.userUpdate(JSON.stringify(userData), "requestQuote");
      const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("B (PowerMate)(spineatools)", "RequestQuoteClick");
      } else {
        this.setAnalytics("B (PowerMate)", "RequestQuoteClick");
      }
    } else {
      // console.log("All the data is not filled yet");
    }
  }
  processSubmit() {
    debugger;
    this.formSubmitted = true;
    if (this.userDetails.valid) {
      const userData = {
        FirstName: this.userDetails.get('fName')?.value,
        LastName: this.userDetails.get('lName')?.value,
        email: this.userDetails.get('email')?.value,
        Company: this.userDetails.get('company')?.value,
        City: this.userDetails.get('city')?.value,
        State: this.userDetails.get('state')?.value,
        Country: this.userDetails.get('country')?.value,
        ContactNumber: this.userDetails.get('phone')?.value,
        Quantity: this.userDetails.get('quantity')?.value || null,
        Comment: this.userDetails.get('comment')?.value || null,
        Request: this.fileRequest || null,
        Code: this.productCode
      };
      this.firstName = userData.FirstName
      this.quoteUserData = {
        quantity: userData.Quantity,
        email: userData.email,
        firstName: userData.FirstName,
        lastName: userData.LastName,
        company: userData.Company,
        city: userData.City,
        state: userData.State,
        country: userData.Country,
        mobile: userData.ContactNumber,
        comment: userData.Comment
      };
      this.firstName = userData.FirstName
      this.userRegister(JSON.stringify(userData));
      if (this.userDetails.valid) {
        $('#closeRegisterModal').click();
      }

    } else {
      // console.log("All the data is not filled yet");
    }
  }
  public userRegister(reducer: any): void {
    this.userRegisterService.userRegister(reducer).subscribe(result => {
      if (result.body == true) {
        this.funRemove();
        this.assignRequestQuote();
        this.userLoginStatus = true;
        this.getUserRegister("");
        if (this.fileType == "specification") {
          document.cookie = "CookiesCode=" + this.productCode;
            const currentUrl = window.location.href.toLowerCase();
          if (currentUrl.includes('spineatools')) {
            this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
          } else {
            this.setAnalytics("B (PowerMate)", "RegisterClick");
          }
          this.generatePdf();
          this.showSuccess("Success", "Spec Sheet Downloaded");
        }
        if (this.fileType == "drawing2Ddownload") {
          document.cookie = "CookiesCode=" + this.productCode;
          const currentUrl = window.location.href.toLowerCase();
          if (currentUrl.includes('spineatools')) {
            this.setAnalytics("B (PowerMate)(spineatools)", "RegisterClick");
          } else {
            this.setAnalytics("B (PowerMate)", "RegisterClick");
          }
          this.download2dDimensionedFileSeriesB();
          this.showSuccess("Success", "2D Dimensional File has been Downloaded");
        }
        if (this.fileType == "requestQuote") {
          document.cookie = "CookiesCode=" + this.productCode;
          const currentUrl = window.location.href.toLowerCase();
          if (currentUrl.includes('spineatools')) {
            this.setAnalytics("B (PowerMate)(spineatools)", "RequestQuoteClick");
          } else {
            this.setAnalytics("B (PowerMate)", "RequestQuoteClick");
          }
          this.showConfirm(this.firstName);
        }
      }
    });
  }
  userProfiles: any[] = [];
  showEmailSearch: boolean = false;
  searchEmail: string = '';

  public getUserRegister(reducer: any): void {
    this.userRegisterService.getuserRegister(reducer).subscribe({
      next: (result) => {

        if (result != null && result.length > 0) {
          if (result.length > 1) {
            // Multiple profiles found - prompt for email search
            this.userProfiles = result;
            this.showEmailSearch = true;
            //this.showProfileSelection = false;
            console.log('Multiple profiles found:', result.length, '- prompting for email search');
            console.log('DEBUG: typeof result:', typeof result, 'isArray:', Array.isArray(result), 'value:', result);
            try {
              console.log('User profiles:', JSON.stringify(result, null, 2));
            } catch (e) {
              console.error('JSON.stringify failed:', e);
            }
          } else if (result.length === 1) {
            // Single profile - auto-populate form
            console.log('User data before populate:', JSON.stringify(result[0], null, 2));
            this.populateForm(result[0]);
            console.log('Single profile found - auto-populated');
          }
        }
        else {
          // No existing profile found - user can enter new details
          console.log('No existing profile found for this IP');
        }

      }
    });
  }
  public userUpdate(reducer: any, typeofFile: any): void {
    this.userRegisterService.userUpdate(reducer).subscribe(result => {
      if (result != null) {
        this.userLoginStatus = true;
        this.funRemove();
        this.assignRequestQuote();
        if (typeofFile == "requestQuote") {
          this.showConfirm(this.UserDBData.firstName);
          this.processAndSendPDF();
        }
        // this.userSharedService.setUserInformation(result);
      } else {
        this.funGet();
      }
    });
  }

  UserDBInformation() {
    debugger;
    this.userSharedService.userDetails$.subscribe((userData: any) => {
      this.UserDBData = userData;
      console.log("I am user Registered Data");
      console.log(this.UserDBData);
    });
  }

  constructor(private cadService: CadService, private sharedDataService: SharedDataService, private sendmail: SendMailService, private http: HttpClient, private userSharedService: SharedUserRegisterService, private userRegisterService: UserRegisterService, private messageService: MessageService, private formBuilder: FormBuilder, public dialog: MatDialog, private bService: BServiceService, private bSharedService: BSharedServiceService, private pdfService: PdfService, private renderer: Renderer2, private service: NemaService, private router: Router, private snackBar: MatSnackBar) {
    this.basePath = environment.imgPathUrl;
    this.AssetbasePath = environment.assetsPath;
  };
  imageUrl: any;
  basePath: any;
  AssetbasePath: any;
  specData: any = {};
  cadData: any = {};
  productDetails: any = {};
  modifiedSize: any;
  kitData: any = {};
  quoteUserData: any = {};
  CADfileFormat = {
    CAD2DFileFormat: '.dxf',
    CAD3DFileFormat: '.stp',
  };
  productCode: any;
  dutyCycle: any;
  inputPower: any;
  Units: any;
  Speed: any;
  Ratio: any;
  DutyCycle: any;
  ServiceFactor: any;
  OutputSpeed: any;
  public showspinfo: boolean = false;
  public showcdinfo: boolean = false;
  // constructor(){}
  ngOnInit() {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) {
      this.showspinfo = true;
      this.showcdinfo = false;
    }
    else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
    this.init();
    this.validateRequestQuote();
    this.getUserRegister("");
    this.bSharedService.getFormData().subscribe(data => {
      this.dutyCycle = data.selectedDutyCycle;
      this.inputPower = data.selectedInputPower;
      this.Units = data.selectedUnits;
      this.Speed = data.selectedSpeed;
      this.Ratio = data.selectedRatio;
      this.DutyCycle = data.selectedDutyCycle;
      this.ServiceFactor = data.selectedServiceFactor;
      this.OutputSpeed = data.selectedOutputSpeed;
    });
    this.sharedDataService.cadChange$.subscribe((data: any) => {
      if (data == "true") {
        const cadGenArea: any = document.getElementById('cadGenerateArea');
        const cadProArea: any = document.getElementById('cadProcessArea');
        const cadShArea: any = document.getElementById('cadShownArea');
        if (cadGenArea) {
          // Check if the div is currently visible
          if (cadGenArea.style.display === 'none') {
            // Show the div
            cadGenArea.style.display = 'block';
            cadProArea.style.display = 'none';
            cadShArea.style.display = 'none';
          }
        }
      }

    });
    this.userSharedService.userDetails$.subscribe((userData: any) => {
      this.UserDBData = userData;
    });
    this.bSharedService.productCode$.subscribe((data: any) => {
      this.signalStatus = true;
      this.panelOpenState = signal(this.signalStatus);
      this.productCode = data;
      console.log("Product Details From Final RG is", this.productCode);
    });
    this.bSharedService.specification$.subscribe((specificationData: any) => {
      console.log("This is final data from BB", specificationData);
      this.specData = {
        Effieciency: specificationData.Effieciency == "N/A" ? specificationData.Effieciency : specificationData.Effieciency + " %",
        InputPowerMech: specificationData.InputPowerMech == "N/A" ? specificationData.InputPowerMech : specificationData.InputPowerMech + " HP",
        InputPowerTherm: specificationData.InputPowerTherm == "N/A" ? specificationData.InputPowerTherm : specificationData.InputPowerTherm + " HP",
        InputSpeed: specificationData.InputSpeed,
        NominalRatio: specificationData.NominalRatio,
        OutputSpeed: specificationData.OutputSpeed,
        OutputTorque: specificationData.OutputTorque == "N/A" ? specificationData.OutputTorque : specificationData.OutputTorque + " lb-in",
        PowerType: specificationData.PowerType,
        Series: specificationData.Series,
        UnitDesignation: specificationData.UnitDesignation,
        specServiceFactor: specificationData.specServiceFactor,
        InputPowerMech_Met: specificationData.InputPowerMech_Met == "N/A" ? specificationData.InputPowerMech_Met : specificationData.InputPowerMech_Met + " kW",
        InputTorque_Imp: specificationData.InputTorque_Imp == "N/A" ? specificationData.InputTorque_Imp : specificationData.InputTorque_Imp + " lb-in",
        InputTorque_Met: specificationData.InputTorque_Met == "N/A" ? specificationData.InputTorque_Met : specificationData.InputTorque_Met + " Nm",
        InputTorqueAccel_Imp: specificationData.InputTorqueAccel_Imp == "N/A" ? specificationData.InputTorqueAccel_Imp : specificationData.InputTorqueAccel_Imp + " lb-in",
        InputTorqueAccel_Met: specificationData.InputTorqueAccel_Met == "N/A" ? specificationData.InputTorqueAccel_Met : specificationData.InputTorqueAccel_Met + " Nm",
        InputPowerThermal_Met: specificationData.InputPowerThermal_Met == "N/A" ? specificationData.InputPowerThermal_Met : specificationData.InputPowerThermal_Met + " kW",
        OutputTorque_Met: specificationData.OutputTorque_Met == "N/A" ? specificationData.OutputTorque_Met : specificationData.OutputTorque_Met + " Nm",
        OutputTorqueAccel_Imp: specificationData.OutputTorqueAccel_Imp == "N/A" ? specificationData.OutputTorqueAccel_Imp : specificationData.OutputTorqueAccel_Imp + " lb-in",
        OutputTorqueAccel_Met: specificationData.OutputTorqueAccel_Met == "N/A" ? specificationData.OutputTorqueAccel_Met : specificationData.OutputTorqueAccel_Met + " Nm"
      };
      this.modifiedSize = this.specData.UnitDesignation.substring(1, 3);
    });

    this.bSharedService.kit$.subscribe((kitData: any) => {
      this.kitData = kitData;
    });
    this.bSharedService.cad$.subscribe((cadData: any) => {
      this.cadData = {
        location: cadData.location,
        code: cadData.code
      }
      console.log("Cad Location Details: ", this.cadData);
    });
    this.bSharedService.productSpecification$.subscribe((data: any) => {
      this.productDetails = data;
      console.log("Product Details From Final", this.productDetails);
    });
  }




  onCAD2DFileChange(event: any) {
    const selectedValue = event.target.value;
    this.CADfileFormat.CAD2DFileFormat = selectedValue;
  }
  onCAD3DFileChange(event: any) {
    const selectedValue = event.target.value;
    this.CADfileFormat.CAD3DFileFormat = selectedValue;
  }
  generatePdf() {
    const url = this.router.url.toLowerCase();
    let companyName: string;
    let companyAddress: string;
    let contactInfo: string;
    let website: string;
    const currentUrl = window.location.href.toLowerCase();

    {
      if (currentUrl.includes('spineatools')) {
        companyName = "SPINEA";
        companyAddress = "s.r.o., Ku Magašu 702/3, 080 01 Haniska, Dist. Prešov, Slovakia";
        contactInfo = "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156";
        website = "www.spinea.com"

      }
      else {
        companyName = "Cone Drive Operations, Inc.";
        companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
        contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
        website = "www.conedrive.com";
      }
      const tableId = 'specification';
      const tableId2 = 'specificationDetails';
      const userInputTable = 'userInput';
      const tableId3 = 'kitDetails';
      const productCode = this.cadData.code;
      const productName = "Series B"

      this.pdfService.generatePdfB(companyName, companyAddress, contactInfo, website, tableId, tableId2, tableId3, productCode, productName, userInputTable);
    }
  }
    createCAD(): void {
      debugger;
      const cadGenArea: any = document.getElementById('cadGenerateArea');
      const cadProArea = document.getElementById('cadProcessArea');
      const cadShArea: any = document.getElementById('cadShownArea');
      if(cadProArea) {
        // Check if the div is currently visible
        if (cadProArea.style.display === 'none') {
          // Show the div
          cadGenArea.style.display = 'none';
          cadProArea.style.display = 'block';
        }
      }
    this.cadService.showCADImage(this.cadData.location + "\\" + this.cadData.code).subscribe({
        next: (response) => {
          debugger;
          const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
          const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
          this.imageUrl = imageUrl;
          if (this.imageUrl) {
            debugger;
            const imgElement = document.getElementById('cadImage');
            if (imgElement) {
              this.renderer.setAttribute(imgElement, 'src', imageUrl);
              if (cadProArea) {
                if (cadProArea.style.display === 'block') {
                  cadProArea.style.display = 'none';
                  cadShArea.style.display = 'block';
                }
              }
            }
          }
        },
        error: (error) => {
          console.error('Error downloading image:', error); // Handle errors
        }
      });

    }

    checkImageAvailability(imageUrl: string): void {
      debugger;
      const cadProArea = document.getElementById('cadProcessArea');
      const cadShArea: any = document.getElementById('cadShownArea');
      fetch(imageUrl, { method: 'HEAD' })  // Use 'HEAD' to check only the status
      .then(response => {
        debugger;
        console.log(response.status);
        if (response.status === 404) {
          this.checkImageAvailability(imageUrl);
        } else {
          // this.loadImage(imageUrl);
          console.log(response.status);
          const imgElement = document.getElementById('cadImage');
          if (imgElement) {
            this.renderer.setAttribute(imgElement, 'src', imageUrl);
            if (cadProArea) {
              // Check if the div is currently visible
              if (cadProArea.style.display === 'block') {
                // Show the div
                cadProArea.style.display = 'none';
                cadShArea.style.display = 'block';
              }
            }
          }
        }
      })
        .catch(() => {
          console.log("Network error or invalid URL.");
        });
    }
  public download3DPDF() {
    debugger;
    this.cadService.downloadCADFiles(this.cadData.location + "\\" + this.cadData.code, ".pdf", this.cadData.code)
  }
  public download3DFile() {
    debugger;
    this.cadService.downloadCADFiles(this.cadData.location + "\\" + this.cadData.code, ".stp", this.cadData.code)
  }
  public download2DFile() {
    debugger;
    this.cadService.downloadCADFiles(this.cadData.location + "\\" + this.cadData.code, ".dxf", this.cadData.code)
  }
  sendPDFToAPI(pdfBlob: Blob) {
    const apiUrl = 'https://localhost:7225/api/UserRegistration/sendemail';  // Your C# API URL

    // Create FormData and append the PDF Blob
    const formData = new FormData();
    formData.append('pdf', pdfBlob, 'Quote' + this.cadData.code + '.pdf'); // Name the file as 'generated.pdf'

    // Send POST request with FormData to the C# API
    this.http.post(apiUrl, formData).subscribe(response => {
      console.log('PDF sent to server successfully!', response);
    });
  }
  processAndSendPDF() {
    const url = this.router.url.toLowerCase();
    let companyName: string;
    let companyAddress: string;
    let contactInfo: string;
    let website: string;
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) {

      companyName = "SPINEA";
      companyAddress = "s.r.o., Ku Magašu 702/3, 080 01 Haniska, District of Prešov, Slovakia";
      contactInfo = "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156";
      website = "www.spinea.com"

    }
    else {
      companyName = "Cone Drive Operations, Inc.";
      companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
      contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
      website = "www.conedrive.com";
    }
    const tableId = 'specification';
    const tableId2 = 'specificationDetails';
    const tableId3 = 'kitDetails';
    const productCode = this.cadData.code;
    const productName = "Series B"
    const userInputTable = 'userInput';


    const pdfBlob = this.pdfService.bPdfRequestQuote(companyName, companyAddress, contactInfo, website, tableId, tableId2, tableId3, productCode, productName, this.quoteUserData, userInputTable);
    this.sendMail(pdfBlob);  // Send it to the API to send the email

  }
  public sendMail(pdfBlob: Blob): void {
    // Call the sendPDFToAPI method and handle the result
    this.sendmail.sendPDFToAPI(pdfBlob, this.cadData.code, this.quoteUserData);

  }


  download2dDimensionedFileSeriesB() {
    var size = this.cadData.code.substr(0, 3);
    var img_std_Dimensions = "";

    // var img_std_Dimensions = this.basePath+"/B/" + size + "//" + size + "_std.png";
    var img_col9 = "";
    var img_col10_12 = "";
    // var img_col10_12_15="";
    var img_col11 = "";

    this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_std", ".png").subscribe({
      next: (response) => {
        debugger;
        const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
        const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
        img_std_Dimensions = imageUrl;
        if (this.cadData.code.substr(8, 1) != "W") {
          this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col9_" + this.cadData.code.substr(8, 1), ".png").subscribe({
            next: (response) => {
              debugger;
              const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
              const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
              img_col9 = imageUrl;
              this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col11_" + this.cadData.code.substr(10, 1), ".png").subscribe({
                next: (response) => {
                  debugger;
                  const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                  const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                  img_col11 = imageUrl;
                  if ((this.cadData.code.substr(14, 1) == "G") || (this.cadData.code.substr(14, 1) == "H")) {
                    this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col10_12_15_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1), ".png").subscribe({
                      next: (response) => {
                        debugger;
                        const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                        const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                        img_col10_12 = imageUrl;
                        this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col11_" + this.cadData.code.substr(10, 1), ".png").subscribe({
                          next: (response) => {
                            debugger;
                            const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                            const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                            img_col11 = imageUrl;
                            const companyName = "Cone Drive Operations, Inc.";
                            const companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
                            const contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
                            const website = "www.conedrive.com";
                            const tableId = 'specification';
                            // const tableId2='specificationDetails';
                            const productCode = this.cadData.code;
                            const productName = "Series B";

                            this.pdfService.generateDimensionalPDF_B(companyName, companyAddress, contactInfo, website, tableId, productCode, productName, img_std_Dimensions, img_col9, img_col10_12, img_col11);
                          },
                          error: (error) => {
                            console.error('Error in second image:', error); // Handle errors
                          }
                        });
                      },
                      error: (error) => {
                        console.error('Error in second image:', error); // Handle errors
                      }
                    });
                    // img_col10_12 = this.basePath+"/B/" + size + "//" + size + "_Col10_12_15_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1) + ".png";
                  }
                  else {
                    this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col10_12_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1), ".png").subscribe({
                      next: (response) => {
                        debugger;
                        const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                        const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                        img_col10_12 = imageUrl;
                        this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col11_" + this.cadData.code.substr(10, 1), ".png").subscribe({
                          next: (response) => {
                            debugger;
                            const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                            const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                            img_col11 = imageUrl;
                            const companyName = "Cone Drive Operations, Inc.";
                            const companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
                            const contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
                            const website = "www.conedrive.com";
                            const tableId = 'specification';
                            // const tableId2='specificationDetails';
                            const productCode = this.cadData.code;
                            const productName = "Series B";

                            this.pdfService.generateDimensionalPDF_B(companyName, companyAddress, contactInfo, website, tableId, productCode, productName, img_std_Dimensions, img_col9, img_col10_12, img_col11);
                          },
                          error: (error) => {
                            console.error('Error in second image:', error); // Handle errors
                          }
                        });
                      },
                      error: (error) => {
                        console.error('Error in second image:', error); // Handle errors
                      }
                    });
                    // img_col10_12 = this.basePath+"/B/" + size + "//" + size + "_Col10_12_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1) + ".png";
                  }
                },
                error: (error) => {
                  console.error('Error in second image:', error); // Handle errors
                }
              });
            },
            error: (error) => {
              console.error('Error in second image:', error); // Handle errors
            }
          });
          // img_col9 = this.basePath+"/B/" + size + "//" + size + "_Col9_" + this.cadData.code.substr(8, 1) + ".png";
        } else if ((this.cadData.code.substr(14, 1) == "G") || (this.cadData.code.substr(14, 1) == "H")) {
          this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col10_12_15_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1), ".png").subscribe({
            next: (response) => {
              debugger;
              const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
              const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
              img_col10_12 = imageUrl;
              this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col11_" + this.cadData.code.substr(10, 1), ".png").subscribe({
                next: (response) => {
                  debugger;
                  const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                  const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                  img_col11 = imageUrl;
                  const companyName = "Cone Drive Operations, Inc.";
                  const companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
                  const contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
                  const website = "www.conedrive.com";
                  const tableId = 'specification';
                  // const tableId2='specificationDetails';
                  const productCode = this.cadData.code;
                  const productName = "Series B";

                  this.pdfService.generateDimensionalPDF_B(companyName, companyAddress, contactInfo, website, tableId, productCode, productName, img_std_Dimensions, img_col9, img_col10_12, img_col11);
                },
                error: (error) => {
                  console.error('Error in second image:', error); // Handle errors
                }
              });
            },
            error: (error) => {
              console.error('Error in second image:', error); // Handle errors
            }
          });
          // img_col10_12 = this.basePath+"/B/" + size + "//" + size + "_Col10_12_15_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1) + ".png";
        }
        else {
          this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col10_12_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1), ".png").subscribe({
            next: (response) => {
              debugger;
              const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
              const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
              img_col10_12 = imageUrl;
              this.cadService.showDimensionImage("SeriesB" + "/" + size + "/" + size + "_Col11_" + this.cadData.code.substr(10, 1), ".png").subscribe({
                next: (response) => {
                  debugger;
                  const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
                  const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
                  img_col11 = imageUrl;
                  const companyName = "Cone Drive Operations, Inc.";
                  const companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
                  const contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
                  const website = "www.conedrive.com";
                  const tableId = 'specification';
                  // const tableId2='specificationDetails';
                  const productCode = this.cadData.code;
                  const productName = "Series B";

                  this.pdfService.generateDimensionalPDF_B(companyName, companyAddress, contactInfo, website, tableId, productCode, productName, img_std_Dimensions, img_col9, img_col10_12, img_col11);
                },
                error: (error) => {
                  console.error('Error in second image:', error); // Handle errors
                }
              });
            },
            error: (error) => {
              console.error('Error in second image:', error); // Handle errors
            }
          });
          // img_col10_12 = this.basePath+"/B/" + size + "//" + size + "_Col10_12_" + this.cadData.code.substr(9, 1) + this.cadData.code.substr(11, 1) + ".png";
        }
      },
      error: (error) => {
        console.error('Error in second image:', error); // Handle errors
      }
    });




    //  img_col11 = this.basePath+"/B/" + size + "//" + size + "_Col11_" + this.cadData.code.substr(10, 1) + ".png";








  }

  showRegisterForm() {
    debugger;
    $('#commonRegisterModal').css("display", "block");
    $('#exampleModal').css("display", "block");

  }
  closeRegisterModal() {
    debugger;
    $('#commonRegisterModal').css("display", "none");
  }
  closePrivacyModal() {
    debugger;
    $('#exampleModal').css("display", "none");
    $('#policyCheck').prop('checked', false);
  }
  PrivacySubmit() {
    $('#exampleModal').css("display", "none");
    $('#policyCheck').prop('checked', true);
  }

  setAnalytics(product: string, clickType: string) {
    this.service.setDataAnalytics(product, clickType).subscribe(result => {
    },
      (error) => {
        console.error('Error Data Analytics :', error);
      })
  }

  populateForm(user: any) {
    console.log('=== POPULATE FORM DEBUG ===');
    console.log('Full user object:', JSON.stringify(user, null, 2));
    console.log('Country field value:', user.country);
    console.log('Country field type:', typeof user.country);

    // Check for different possible country field names (case-insensitive) and TRIM
    let countryCode = (user.country || user.Country || user.COUNTRY || '').trim();
    console.log('Resolved country code (raw):', countryCode);

    // If country is a full name, try to convert to code
    if (countryCode && countryCode.length > 3) {
      const lowerCountry = countryCode.toLowerCase();
      if (this.countryNameToCode[lowerCountry]) {
        countryCode = this.countryNameToCode[lowerCountry];
        console.log('Converted country name to code:', countryCode);
      } else {
        console.warn('Country name not found in mapping:', countryCode);
      }
    }

    console.log('Final country code to use:', countryCode);
    setTimeout(() => {
      this.userDetails.get('country')?.setValue(countryCode, { emitEvent: true });
      this.userDetails.get('country')?.updateValueAndValidity();
      // Then patch the rest
      this.userDetails.patchValue({
        fName: (user.firstName || '').trim(),
        lName: (user.lastName || '').trim(),
        company: (user.company || '').trim(),
        city: (user.city || '').trim(),
        state: (user.state || '').trim(),
        email: (user.email || '').trim(),
        phone: (user.contactNumber || '').trim()
      }, { emitEvent: false });
      // Verify the form value after patching
      console.log('Form country value after patch:', this.userDetails.get('country')?.value);
      console.log('All form values:', this.userDetails.value);
      console.log('Form valid:', this.userDetails.valid);
      console.log('Country control errors:', this.userDetails.get('country')?.errors);
      console.log('=== END DEBUG ===');
    }, 100);
  }

  emailNotFound: boolean = false;
  searchByEmail(): void {
    if (!this.searchEmail || !this.searchEmail.trim()) {
      console.warn('No email entered for search');
      return;
    }

    const email = this.searchEmail.trim().toLowerCase();
    console.log('Searching for email:', email);
    console.log('Total profiles to search:', this.userProfiles.length);

    // Log all emails in userProfiles for debugging
    this.userProfiles.forEach((profile, index) => {
      console.log(`Profile ${index}:`, {
        email: profile.email,
        Email: profile.Email,
        allKeys: Object.keys(profile)
      });
    });

    // Search for the email in userProfiles - check both 'email' and 'Email' fields
    const foundProfile = this.userProfiles.find(profile => {
      const profileEmail = (profile.email || profile.Email || '').trim().toLowerCase();
      console.log(`Comparing "${profileEmail}" with "${email}"`);
      return profileEmail === email;
    });

    if (foundProfile) {
      console.log('Profile found for email:', email, foundProfile);
      this.populateForm(foundProfile);
      this.showEmailSearch = false;
      this.emailNotFound = false;
      this.searchEmail = '';
    } else {
      console.log('No profile found for email:', email);
      this.emailNotFound = true;
      this.snackBar.open('Email address not found in our records. Please enter manually or try a different email.', 'Close', {
        duration: 4000,
        panelClass: ['snackbar-error']
      });
      //this.cdr.detectChanges();
    }
  }
  clearEmailSearch(): void {
    this.searchEmail = '';
    this.emailNotFound = false;
  }
}
